export default {
  title: 'Indstillinger',
  fields: {
    discount_type: {
      label: 'Rabattype',
    },
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
  },
  toasts: {
    update_successful: 'Opdateret',
    updated_failed: 'Opdateringen mislykkedes',
  },
};
